import React from "react";
import { Plus, Minus, Trash2, PlusCircle } from "react-feather";

const getCurrency = () => localStorage.getItem("currencycode") || "₹";

const money = (value) => {
  const n = Number(value || 0);
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BillItemList = ({
  billItems,
  handleQuantityChange,
  handleRemoveItem,
}) => {
  const currency = getCurrency();

  return (
    <div className="ns-counter-bill-items-shell">
      <style>{`
        .ns-counter-bill-items-shell {
          min-height: 0;
        }

        .ns-counter-bill-items {
          display: grid;
          gap: 8px;
        }

        .ns-counter-empty-bill {
          min-height: 220px;
          border-radius: 22px;
          border: 1px dashed rgba(100, 116, 139, 0.28);
          background:
            radial-gradient(circle at top, rgba(37, 99, 235, 0.08), transparent 36%),
            #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #64748b;
          padding: 24px;
        }

        .ns-counter-empty-icon {
          width: 58px;
          height: 58px;
          border-radius: 20px;
          background: #eff6ff;
          color: #1d4ed8;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 14px;
        }

        .ns-counter-empty-bill strong {
          color: #0f172a;
          font-size: 0.96rem;
          font-weight: 950;
          margin-bottom: 6px;
        }

        .ns-counter-empty-bill span {
          max-width: 280px;
          font-size: 0.8rem;
          line-height: 1.45;
          font-weight: 760;
        }

        .ns-counter-bill-row {
          background: #ffffff;
          border: 1px solid rgba(15, 23, 42, 0.08);
          border-radius: 18px;
          padding: 10px;
          display: grid;
          grid-template-columns: minmax(0, 1fr) auto;
          gap: 10px;
          align-items: center;
          box-shadow: 0 8px 20px rgba(15, 23, 42, 0.045);
        }

        .ns-counter-item-copy {
          min-width: 0;
        }

        .ns-counter-item-copy strong {
          display: block;
          color: #0f172a;
          font-size: 0.88rem;
          font-weight: 950;
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .ns-counter-item-copy span {
          display: block;
          color: #64748b;
          font-size: 0.72rem;
          font-weight: 800;
          margin-top: 3px;
        }

        .ns-counter-item-actions {
          display: flex;
          align-items: center;
          gap: 7px;
          flex: 0 0 auto;
        }

        .ns-counter-qty-btn,
        .ns-counter-remove-btn {
          width: 32px;
          height: 32px;
          border-radius: 12px;
          border: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: transform 0.14s ease, background 0.14s ease;
        }

        .ns-counter-qty-btn:hover,
        .ns-counter-remove-btn:hover {
          transform: translateY(-1px);
        }

        .ns-counter-qty-btn.minus {
          background: #f1f5f9;
          color: #475569;
        }

        .ns-counter-qty-btn.plus {
          background: #1d4ed8;
          color: #ffffff;
        }

        .ns-counter-remove-btn {
          background: #fef2f2;
          color: #dc2626;
        }

        .ns-counter-qty-input {
          width: 52px;
          height: 32px;
          border: 1px solid rgba(15, 23, 42, 0.12);
          border-radius: 11px;
          text-align: center;
          color: #0f172a;
          font-size: 0.82rem;
          font-weight: 900;
          outline: none;
        }

        .ns-counter-line-amount {
          min-width: 78px;
          color: #0f172a;
          font-size: 0.86rem;
          font-weight: 950;
          text-align: right;
          white-space: nowrap;
        }

        @media (max-width: 560px) {
          .ns-counter-bill-row {
            grid-template-columns: 1fr;
          }

          .ns-counter-item-actions {
            justify-content: space-between;
          }
        }
      `}</style>

      {billItems.length === 0 ? (
        <div className="ns-counter-empty-bill">
          <div className="ns-counter-empty-icon">
            <PlusCircle size={28} />
          </div>
          <strong>Add items to start billing</strong>
          <span>Search or tap menu items from the left side. Items will appear here for settlement.</span>
        </div>
      ) : (
        <div className="ns-counter-bill-items">
          {billItems.map((item) => (
            <div key={item.menu_id} className="ns-counter-bill-row">
              <div className="ns-counter-item-copy">
                <strong title={item.name}>{item.name}</strong>
                <span>
                  {currency}{money(item.price)} each
                </span>
              </div>

              <div className="ns-counter-item-actions">
                <button
                  type="button"
                  className="ns-counter-qty-btn minus"
                  onClick={() => handleQuantityChange(item.menu_id, -1)}
                  disabled={item.qty <= 0.1}
                  aria-label="Decrease quantity"
                >
                  <Minus size={14} />
                </button>

                <input
                  className="ns-counter-qty-input"
                  type="number"
                  value={item.qty}
                  onChange={(event) => {
                    const newQty = parseFloat(event.target.value) || 0;
                    if (newQty >= 0) {
                      handleQuantityChange(item.menu_id, newQty - item.qty);
                    }
                  }}
                  step="0.01"
                  min="0"
                />

                <button
                  type="button"
                  className="ns-counter-qty-btn plus"
                  onClick={() => handleQuantityChange(item.menu_id, 1)}
                  aria-label="Increase quantity"
                >
                  <Plus size={14} />
                </button>

                <span className="ns-counter-line-amount">
                  {currency}{money(item.amount)}
                </span>

                <button
                  type="button"
                  className="ns-counter-remove-btn"
                  onClick={() => handleRemoveItem(item.menu_id)}
                  aria-label="Remove item"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BillItemList;
